const formatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
var moment = require('moment');
import VueCookies from 'vue-cookies'

const bookinghelpers = {
    validateBirthdate() {
        var today = new Date();
        var birthDate = new Date(this.formData.birthdate);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        if (age >= 18) {
            this.msg['birthdate'] = '';
            return true;
        } else {
            if (this.formData.birthdate) {
                this.msg['birthdate'] = this.$t('You must be 18 years or older');
            }
            return false;
        }
    },
    debounceValidateEmail: _.debounce(function () {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.formData.email) || this.formData.email == "") {
            this.msg['email'] = '';
            return true;
        } else {
            if (this.formData.email) {
                this.msg['email'] = this.$t('Please enter a valid email address');
            }
            return false;
        }
    }, 500),
    validateEmail() {
        return this.debounceValidateEmail();
    },
    validatePhone() {
        if (this.$refs.phoneNumberField && this.$refs.phoneNumberField.isValid) {
            this.msg['phoneNumber'] = ''
            return true;
        } else {
            if (this.formData.phoneNumber) {
                this.msg['phoneNumber'] = this.$t('Please enter a valid phone number')
            }
            return false;
        }
    },

    getUpsells() {
        try {
            var upsells = []
            var optionalUpsells = []
            var deposits = []
            for (var roomsetup of JSON.parse(this.setup)) {
                for (let room_number = 0; room_number < parseInt(roomsetup.split("_")[1]); room_number++) {
                    var obj = {};
                    obj[roomsetup.split("_")[0]] = JSON.parse(this.prices).find(x => x.roomID == roomsetup.split('_')[0]).data.upsell;
                    var ups = Object.entries(JSON.parse(this.prices).find(x => x.roomID == roomsetup.split('_')[0]).data.upsell).map((e) => ({ [e[0]]: e[1] }));
                    upsells.push(obj);
                    var opt = ups.find(x => x[Object.keys(x)[0]].type == 1 || x[Object.keys(x)[0]].type == 3 || x[Object.keys(x)[0]].type == 5)
                    opt ? optionalUpsells.push(opt) : null
                    var deposit = ups.find(x => x[Object.keys(x)[0]].period == 3)
                    if (deposit) {
                        deposit['roomID'] = roomsetup.split("_")[0]
                        deposit['propID'] = JSON.parse(this.rooms)[JSON.parse(this.rooms)[roomsetup.split("_")[0]].id].propID
                        deposits.push(deposit)
                    }
                }
            }
            this.optionalUpsells = optionalUpsells
            this.deposits = deposits

            var selected_upsells = VueCookies.get('upsells') ? VueCookies.get('upsells') : [];
            for (var item of selected_upsells) {
                var blocks = item.split("_")
                if (upsells[blocks[7]][Object.keys(upsells[blocks[7]])[0]][blocks[6]]) {
                    upsells[blocks[7]][Object.keys(upsells[blocks[7]])[0]][blocks[6]].check = true;
                    upsells[blocks[7]][Object.keys(upsells[blocks[7]])[0]][blocks[6]].amount = selected_upsells.filter(x => x == blocks.join('_')).length;
                }
            }
            if (upsells.length == 0 || optionalUpsells.length == 0) {
                this.step = 2
                this.hideUpsells = true
            }

            this.upsells = upsells
        } catch (error) {
            console.log(error)
        }
    },

    goToRoomSelection() {
        var newUrl = this.currentUrl + "/book/"+JSON.parse(this.client).id+"?"
        newUrl += "&checkin=" + moment(this.checkin).format('YYYY-MM-DD')
        newUrl += "&checkout=" + moment(this.checkout).format('YYYY-MM-DD')
        newUrl += "&numAdult=" + this.num_adult
        newUrl += "&numChildren=" + this.num_children
        window.location.href = newUrl;
    },

    calculateTotal(item, key, room_id, room_number, setup, type) {
        if (item && key) {
            this.upsellRefresh = this.upsellRefresh + 1;
            var temp = _.cloneDeep(this.upsells)
            var selected_upsells = VueCookies.get("upsells") ? VueCookies.get("upsells") : [];
            if (item.type == 3) {
                if (type == "min") {
                    if (item.amount < 2) {
                        temp[room_number][room_id][key].check = false;
                        temp[room_number][room_id][key].amount = 0;
                    } else {
                        temp[room_number][room_id][key].check = true;
                        temp[room_number][room_id][key].amount = item.amount - 1;
                    }
                    var index2 = selected_upsells.indexOf('ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number);
                    selected_upsells.splice(index2, 1);
                } else if (type == "plus") {
                    var start = item.amount ? item.amount : 0
                    temp[room_number][room_id][key].check = true;
                    temp[room_number][room_id][key].amount = start + 1;
                    selected_upsells.push('ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number)
                } else {
                    temp[room_number][room_id][key].check = this.$refs['ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number][0].checked;

                    if (!temp[room_number][room_id][key].check) {
                        temp[room_number][room_id][key].amount = 1;
                        selected_upsells.push('ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number)
                    } else {
                        temp[room_number][room_id][key].amount = 0;
                        selected_upsells = selected_upsells.filter(a => a !== 'ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number)
                    }
                }

                this.upsells = temp;
                VueCookies.set("upsells", selected_upsells);
                this.selectedUpsell = selected_upsells;
            } else if (temp[room_number][room_id][key]) {
                temp[room_number][room_id][key].check = this.$refs['ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number][0].checked;

                if (!temp[room_number][room_id][key].check) {
                    temp[room_number][room_id][key].amount = 1;
                    selected_upsells.push('ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number)
                } else {
                    temp[room_number][room_id][key].amount = 0;
                    var index2 = selected_upsells.indexOf('ups_' + room_id + '_' + item.type + '_' + item.unit + '_' + item.period + '_' + parseInt(item.price) + '_' + key + '_' + room_number);
                    selected_upsells.splice(index2, 1);
                }

                this.upsells = temp;
                VueCookies.set("upsells", selected_upsells);
                this.selectedUpsell = selected_upsells;
            }
        }
    },

    async generatePaymentIntent() {
        this.setupPaymentMeta();
        if (this.calculatedTotal == 0 || !this.confirmBooking) {
            this.elementsOptions.clientSecret = null
            return 0;
        }
        if (VueCookies.get('paymentIntent') && VueCookies.get('paymentIntent').amount && VueCookies.get('paymentIntent').amount == this.calculatedTotal  && VueCookies.get('paymentIntent').id == this.PaymentMetaData.id) {
            try {
                this.elementsOptions.clientSecret = VueCookies.get('paymentIntent').client_secret;
                this.loadingStripe++;
            } catch (error) {
                console.log(error)
                VueCookies.remove("paymentIntent")
                this.generatePaymentIntent()
            }
        } else {
            try {
                let response = await fetch(
                    window.location.origin + "/api/payment/initiate",
                    {
                        method: 'POST',
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                        },
                        body: JSON.stringify({
                            clientID: JSON.parse(this.client).id,
                            metadata: this.PaymentMetaData,
                            receipt_email: this.formData.email,
                            amount: this.calculatedTotal,
                            deposit: this.calc_deposit,
                            upsells: this.selectedUpsell,
                            setup: JSON.parse(this.setup),
                            checkin: this.checkin,
                            checkout: this.checkout
                        })
                    }
                );
                const paymentIntent = await response.json();
                this.elementsOptions.clientSecret = paymentIntent.client_secret;
                VueCookies.set('paymentIntent', paymentIntent);
                this.loadingStripe++;
            } catch (error) {
                console.log(error);
            }
        }
        this.confirmParams = {
            return_url: window.location.origin + '/book/'+ JSON.parse(this.client).id +'/result', // success url
            receipt_email: this.formData.email,
            payment_method_data: {
                billing_details: {
                    name: this.formData.first_name + " " + this.formData.last_name,
                    email: this.formData.email,
                    phone: this.formData.phoneNumber,
                    address: {
                        city: this.formData.city,
                        country: this.formData.country.split(",")[0],
                        line1: this.formData.streetname,
                        postal_code: this.formData.postcode
                    }
                },
                metadata: this.PaymentMetaData
            }
        }
    },
}

export default bookinghelpers